module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="rankings-data">\n	<select class="base-select js-change-states">\n		<option value="">\n			All STATES\n		</option>\n		';
 _.each( states, function(item, value) { 
__p+='\n			<option value="'+
((__t=( value ))==null?'':_.escape(__t))+
'" '+
((__t=( (value == state) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>'+
((__t=( item ))==null?'':_.escape(__t))+
'</option>\n		';
 } ) 
__p+='\n	</select>\n\n	<select class="base-select js-change-round">\n		<option value="">All Rounds</option>\n		';
 _.each(rounds, function(round_item) { 
__p+='\n			<option value="'+
((__t=( round_item.id ))==null?'':_.escape(__t))+
'" '+
((__t=( (round == round_item.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n				Round '+
((__t=( round_item.id ))==null?'':_.escape(__t))+
'\n			</option>\n		';
 }) 
__p+='\n	</select>\n	<select class="base-select js-change-clubs">\n		<option value="">\n			All CLUBS\n		</option>\n		';
 _.each( squads, function(squad) { 
__p+='\n			<option value="'+
((__t=( squad.id ))==null?'':_.escape(__t))+
'" '+
((__t=( (squad.id == club) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n				'+
((__t=( squad.full_name ))==null?'':_.escape(__t))+
'\n			</option>\n		';
 } ) 
__p+='\n	</select>\n	<select class="base-select js-change-month">\n		<option value="">\n			All MONTHS\n		</option>\n		';
 _.each( months, function(mon) { 
__p+='\n			<option value="'+
((__t=( mon.val ))==null?'':_.escape(__t))+
'" '+
((__t=( (mon.val == month) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n				'+
((__t=( mon.name ))==null?'':_.escape(__t))+
'\n			</option>\n		';
 } ) 
__p+='\n	</select>\n</div>\n<div class="table-header">\n	<div class="table-item rank-item js-sort-column" data-order="rank">Rank</div>\n	<div class="table-item name js-sort-column" data-order="team_name">Team Name</div>\n	<div class="table-item avatar"></div>\n	<div class="table-item coach js-sort-column" data-order="coach">Coach name</div>\n	<div class="table-item js-sort-column" data-order="total_points">Total Points</div>\n	<div class="table-item js-sort-column '+
((__t=( round == '' ? 'hidden' : '' ))==null?'':_.escape(__t))+
'" data-order="round_points">Round '+
((__t=( round ))==null?'':_.escape(__t))+
' Points</div>\n	<div class="table-item js-sort-column hidden-mobile" data-order="avg_points">Avg points/round</div>\n	<div class="table-item js-sort-column hidden-mobile" data-order="team_value">Team Value</div>\n	<div class="table-item js-sort-column hidden-mobile" data-order="salary_cap">Squad Value</div>\n	';
 if(!is_preseason) { 
__p+='\n		<div class="table-item arrow ">View<br/> Team</div>\n	';
 } 
__p+='\n</div>';
}
return __p;
};
